<template>
  <div class="ui modal" id="base-interaction-modal">
    <div class="header">{{ displayTitle }}</div>
    <i class="close inside icon"></i>
    <div class="scrolling content">
      <component
        v-if="component"
        ref="form"
        :is="component"
        :data="data"
        :id="id"
        :type="type"
        :standard="standard"
        :title="title"
        @valid="setCanSubmit"
        @close="hideModal"
      />
    </div>
    <div class="actions">
      <button
        :class="`ui ${ canSubmit ? '' : 'disabled' } green button`"
        @click="submit"
        v-if="showSubmit"
      >Submit</button>
      <button class="ui grey button" @click="hideModal">Back to Course</button>
    </div>
  </div>
</template>

<script>
import Note from './views/Note';
import SelectAllThatApply from './views/SelectAllThatApply';
import MultipleChoice from './views/MultipleChoice';
import Poll from './views/Poll';
import ThoughtQuestion from './views/ThoughtQuestion';
import YoutubePlayer from './views/YouTube';
import WebLink from './views/WebLink';
import FillInTheBlank from './views/FillInTheBlank';

export default {
  name: 'InteractionModal',
  props: ['title', 'type', 'data', 'id', 'standard'],
  components: {
    Note,
    SelectAllThatApply,
    MultipleChoice,
    Poll,
    ThoughtQuestion,
    YoutubePlayer,
    WebLink,
    FillInTheBlank,
  },
  data() {
    return {
      canSubmit: false,
      closed: false,
    };
  },
  computed: {
    component() {
      if (!this.type || this.closed) {
        return null;
      }

      if (this.type === 'ata') {
        return 'SelectAllThatApply';
      } else if (this.type === 'verbal_survey_d') {
        return 'ThoughtQuestion';
      } else if (this.type === 'fitb') {
        return 'FillInTheBlank';
      } else if (this.type === 'bizready') {
        return 'WebLink';
      }

      const comp = this.convertTypeToComponent();
      if (Object.keys(this.$options.components).includes(comp)) {
        return comp;
      }
      return null;
    },
    displayTitle() {
      if (this.type === 'bizready') {
        return 'Enhance Your Learning With AI-Powered Roleplay';
      }
      return this.title;
    },
    showSubmit() {
      const unsubmittedTypes = ['web_link', 'youtube_player', 'poll', 'note', 'bizready'];
      return !unsubmittedTypes.includes(this.type);
    },
  },
  methods: {
    convertTypeToComponent() {
      let typeArr = this.type.split('_');
      typeArr = typeArr.map(str => this.capitalize(str));
      return typeArr.join('');
    },
    capitalize(str) {
      return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    },
    showModal() {
      const _this = this;
      this.closed = false;
      this.$store.commit('video/addEvent', { id: 'pause' });
      $('#base-interaction-modal')
        .modal({
          autofocus: false,
          onHidden() {
            _this.$store.commit('video/addEvent', { id: 'play' });
            _this.closed = true;
          },
        })
        .modal('show');
    },
    hideModal() {
      $('#base-interaction-modal').modal('hide');
    },
    setCanSubmit(valid) {
      this.canSubmit = valid;
    },
    submit() {
      if (this.$refs.form.submit) {
        this.$refs.form.submit();
      }
    },
  },
  destroyed() {
    $('#base-interaction-modal').remove();
  },
};
</script>
